import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  width: 450px;
  img {
    height: 95px;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
    padding-top: ${({ theme: { reference } }) => reference.dimension_40};
  }
`;

export const NextStepsContainer = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  border: 1px solid ${({ theme: { system } }) => system.border.fds_sys_color_border_primary};
`;

export const BulletIcon = styled(FlexContainer)`
  border-radius: ${({ theme }) => theme.sizing.fds_borderradius_round};
  width: ${({ theme: { reference } }) => reference.dimension_24};
  height: ${({ theme: { reference } }) => reference.dimension_24};
  flex: none;
  background: ${({ theme: { system } }) => system.accent.fds_sys_color_accent_cold};
  color: ${({ theme: { system } }) => system.text.fds_sys_color_text_primary_inverse};
  > p {
    line-height: normal;
  }
`;
